module.exports = __webpack_public_path__ + "img/pic_160233_2.9df98f78.jpg";